<woa-modal-page-layout [title]="'woa.heading.reorder.title'" [footerControlOrientation]="'vertical'">
    <woa-order-edit-panel class="reorder-order" [showRetry]="false" [showItemEdit]="false" [disabled]="paying()"
                          [collapseTransferRequests]="false"
                          (onOrderItemRemoved)="orderItemRemoved($event)"></woa-order-edit-panel>
    @if (showQuickPay()) {
        <woa-order-totals-panel slot="footer-start" class="reorder-totals"
                                [showZeroTip]="false" [showSavings]="false"
                                [showPoints]="false"></woa-order-totals-panel>
    }
    @if (!paying()) {
        <woa-button woa-page-footer-control
                    [label]="showQuickPay() ? 'woa.button.reorder.addAndOrderMore' : 'woa.button.reorder.addToOrder'"
                    [prominence]="ButtonProminence.LOW" (onActivate)="addToOrder()"></woa-button>
    }
    @if (showQuickPay()) {
        <woa-quick-pay-panel woa-page-footer-control (pay)="quickPay($event)"></woa-quick-pay-panel>
    }
</woa-modal-page-layout>
